import { render, staticRenderFns } from "./CustomDomainV2.vue?vue&type=template&id=2d88d04a&scoped=true"
import script from "./CustomDomainV2.vue?vue&type=script&lang=js"
export * from "./CustomDomainV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88d04a",
  null
  
)

export default component.exports